import React from 'react';
import PropTypes from 'prop-types';

import { Flex, Span } from '@sopranodesign/pulse-components';
import { TemplatingTextInput } from '@sopranodesign/pulse-templating';

const ExportImportContent = ({ content, onChange }) => {
  const handleImportChange = importId => {
    onChange({ import_id: importId });
  };

  const handleEmailChange = email => {
    onChange({ email });
  };

  return (
    <Flex center fat="true" xSpace>
      <Flex col fat>
        <TemplatingTextInput
          aria-label="Knowledge base identifier"
          placeholder="Knowledge base identifier"
          value={content.import_id}
          onChange={handleImportChange}
        />
      </Flex>
      <Span noWrap>and email to</Span>
      <Flex col fat>
        <TemplatingTextInput
          aria-label="Email"
          placeholder="Email"
          value={content.email}
          onChange={handleEmailChange}
        />
      </Flex>
    </Flex>
  );
};

ExportImportContent.propTypes = {
  onChange: PropTypes.func.isRequired,
  content: PropTypes.shape({
    import_id: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired
  }).isRequired
};

export default ExportImportContent;
